/* eslint-disable promise/param-names */
import { AUTH_GOOGLE, AUTH_MSG_TEXT, AUTH_STATUS_MSG, AUTH_FACEBOOK, AUTH_DEGREE, AUTH_REQUEST, AUTH_SIGNUP, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_REQUEST_DONE, AUTH_JWT_DECODE} from '../actions/auth'
import { SET_GET_SETS } from '../actions/settings'
import { USER_REQUEST } from '../actions/user'
import { MSG_GET_ALL, MSG_GET_USER } from '../actions/messages'
import axios from 'axios'

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  hasLoadedOnce: false,
  degreeKind: localStorage.getItem('user-degree') || '',
  userId: localStorage.getItem('user-id') || '',
  alertMensagem: '',
  alertMensagemShow: false
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  degreeKind: state => state.degreeKind,
  userId: state => state.userId,
  alertMensagem: state => state.alertMensagem,
  alertMensagemShow: state => state.alertMensagemShow
}

const actions = {
  [AUTH_STATUS_MSG]: ({commit, dispatch}, status) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_STATUS_MSG, status);
    })
  },
  [AUTH_MSG_TEXT]: ({commit, dispatch}, text) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_MSG_TEXT, text);
    })
  },
  [AUTH_REQUEST_DONE]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST_DONE);
    })
  },
  [AUTH_JWT_DECODE]: ({commit, dispatch}, code) => {
    return new Promise((resolve, reject) => {
      var degree = code;
      // console.log('degreeee',degree)
      localStorage.setItem('user-degree', degree.sub.degree)
      localStorage.setItem('user-id', degree.sub.user)
      const resp = {userId: degree.sub.user, degree: degree.sub.degree};
      commit(AUTH_JWT_DECODE, resp)
      // dispatch(MSG_GET_ALL)
      //commit(AUTH_DEGREE, degree.sub.degree)
    })
  },
  [AUTH_FACEBOOK]: ({commit, dispatch}, code) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      const urltoken = 'https://api.personalizedenglish.com.br/users/oauth/facebook';
        axios.post(urltoken, { 'access_token': code.code})
        .then(resp => {
          localStorage.setItem('user-token', resp.data.token)
          dispatch(AUTH_JWT_DECODE, resp.data.token)
          commit(AUTH_SUCCESS, resp)
          dispatch(USER_REQUEST, resp.data.user)
          dispatch(SET_GET_SETS, resp.data.settings)
          resolve(resp)
        })
        .catch(err => {
          console.log('saida err:' + err)
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  },
  [AUTH_GOOGLE]: ({commit, dispatch}, code) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      const urltoken = 'https://api.personalizedenglish.com.br/users/oauth/google/token';
        axios.post(urltoken, { 'code': code.code})
        .then(resp => {
          localStorage.setItem('user-token', resp.data.token)
          dispatch(AUTH_JWT_DECODE, resp.data.token)
          commit(AUTH_SUCCESS, resp)
          dispatch(USER_REQUEST, resp.data.user)
          dispatch(SET_GET_SETS, resp.data.settings)
          resolve(resp)
        })
        .catch(err => {
          console.log('saida err:' + err)
          commit(AUTH_ERROR, err)
          localStorage.removeItem('user-token')
          reject(err)
        })
    })
  },
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    console.log('user', user)
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      axios.post('https://api.personalizedenglish.com.br/users/signin', user)
      .then(resp => {
        localStorage.setItem('user-token', resp.data.token)
        // Here set the header of your ajax library to the token value.
        // example with axios
        // axios.defaults.headers.common['Authorization'] = resp.token
        dispatch(AUTH_JWT_DECODE, resp.data.token)
        commit(AUTH_SUCCESS, resp)
         console.log('resp',resp)
        dispatch(USER_REQUEST, resp.data.user)
        dispatch(SET_GET_SETS, resp.data.settings)
        resolve(resp)
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        if(err.response.status===403){
          console.log('err.response.status===403')
          console.log(err.response.data.error)
          dispatch(AUTH_MSG_TEXT, err.response.data.error)
          dispatch(AUTH_STATUS_MSG, true)
        }else{
          console.log('UNKNOWN ERROR')
        }
        localStorage.removeItem('user-token')
        reject(err)
      })
    })
  },
  [AUTH_SIGNUP]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST)
      axios.post('https://api.personalizedenglish.com.br/users/signup', user)
      .then(resp => {
        console.log('resp status signup', resp)
        localStorage.setItem('user-token', resp.data.token)
        // Here set the header of your ajax library to the token value.
        // example with axios
        // axios.defaults.headers.common['Authorization'] = resp.token
        commit(AUTH_SUCCESS, resp)
        dispatch(USER_REQUEST, resp.data.user)
        resolve(resp)
      })
      .catch(err => {
        commit(AUTH_ERROR, err)
        if(err.response.status===403){
          console.log('err.response.status===403')
          console.log(err.response.data.error)
          dispatch(AUTH_MSG_TEXT, err.response.data.error)
          dispatch(AUTH_STATUS_MSG, true)
        }else{
          console.log('UNKNOWN ERROR')
        }

        localStorage.removeItem('user-token')
        reject(err)
      })
    })
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT)
      localStorage.removeItem('user-token')
      localStorage.removeItem('user-id')
      localStorage.removeItem('user-degree')

      FB.logout(function(response) {

        console.log('user is now logged out of facebook');
        console.log(response);
      });

      resolve()
    })
  }
}

const mutations = {
  [AUTH_STATUS_MSG]: (state, status) => {
    state.alertMensagemShow = status
  },
  [AUTH_MSG_TEXT]: (state, text) => {
    state.alertMensagem = text
  },
  [AUTH_JWT_DECODE]: (state, resp) => {
    state.degreeKind = resp.degree
    state.userId = resp.userId
  },
  [AUTH_DEGREE]: (state, degree) => {
    state.degreeKind = degree
  },
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading'
  },
  [AUTH_REQUEST_DONE]: (state) => {
    state.status = 'sucess'
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success'
    state.token = resp.data.token
    state.hasLoadedOnce = true
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error'
    state.hasLoadedOnce = true
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '',
    state.degreeKind = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js